import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        width: "100%",
        height: "26.32vw",
        backgroundColor: Color.DeepBlack
    },
    desktop: {
        width: "19.27vw",
        height: "4.16vw",
        marginBottom: "2.60vw",
        backgroundColor: Color.DeepBlack,
        marginTop: "1.04vw"
    }
};

export const OrganizationDetailsLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;
    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    return (
        <div style={loaderStyles}>
            <ContentLoader
                speed={1}
                backgroundColor={Color.DeepBlack}
                foregroundColor={Color.LoaderForeground}
                width= "auto"
                height= {loaderStyles.height}
            > 
                {isMobile ? <>
                    <rect x="4.8%" y="18.3%" rx="3" ry="3" width="16.6%" height="63.3%" />
                    <rect x="25.1%" y="25.6%" rx="3" ry="3" width="28.7%" height="16.5%" />
                    <rect x="25.1%" y="46.7%" rx="3" ry="3" width="38.4%" height="11.9%" />
                    <rect x="25.1%" y="62.3%" rx="3" ry="3" width="26%" height="11.9%" />
                    <rect x="89%" y="29.3%" rx="3" ry="3" width="6%" height="12.8%" />
                </> : 
                <>
                    <rect x="5.4%" y="0%" rx="3" ry="3" width="21.6%" height="100%" />
                    <rect x="32.4%" y="10%" rx="3" ry="3" width="39.1%" height="28.70%" />
                    <rect x="32.4%" y="53%" rx="3" ry="3" width="21.6%" height="21.25%" />
                    <rect x="32.4%" y="79%" rx="3" ry="3" width="83.2" height="21.25%" />
                </>} 
            </ContentLoader>
        </div>
    );
}